
const MessageBox = (props) => (
  <div className={props.type === "success" ? "alert alert-success" : "alert alert-danger"}>
    {props.message}
  </div>
)

export default MessageBox